import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductComponentBaseMutation(
    $productComponentBase: ProductComponentBaseInput!
  ) {
    createProductComponentBase(
      input: { productComponentBase: $productComponentBase }
    ) {
      productComponentBase {
        id
      }
    }
  }
`;
